let getEnumSelectList = (enumObject) => {
  return Object.keys(enumObject).map((key) => {
    return { label: key, value: enumObject[key] }
  })
};

export { getEnumSelectList };